import { OrderType } from 'src/shared/enum/account_data';

export const getOrderTypeString = (type?: string) => {
  switch (type) {
    case OrderType.DATACODE:
      return 'Nạp data';
    case OrderType.TRANSFEROUT:
      return 'Nhập data';
    case OrderType.ADJUSTINCREASE:
      return 'Điều chỉnh tăng';
    case OrderType.ADJUSTDECREASE:
      return 'Điều chỉnh giảm';
    default:
      return '';
  }
};
